import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import MarkersCaps from '../../images/MarkersCaps';
import MarkersOpened from '../../images/MarkersOpened';

import styles from '../../../../../styles/guest/sections/background/markers.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Markers = ({ active, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.active]: active,
            },
        ])}
    >
        <MarkersOpened className={styles.markersOpened} />
        <MarkersCaps className={styles.markersCaps} />
    </div>
);

Markers.propTypes = propTypes;
Markers.defaultProps = defaultProps;

export default Markers;
